import Vue from 'vue';

export const eventHub = new Vue();

export const eventHubMixin = {
  data() {
    return {
      eventHub,
    };
  },
  methods: {
    emitApiError(text = 'Une erreur s\'est produite, merci de réessayer plus tard.') {
      this.eventHub.$emit('alerts:error', text);
    },

    emitApiSuccess(text = 'Votre modification a bien été prise en compte.') {
      this.eventHub.$emit('alerts:success', text);
    },

    emitOpenModal(key = '', data = {}) {
      this.eventHub.$emit(`modal:${key}:open`, data);
    },

    onOpenModal(key = '', cb) {
      this.eventHub.$on(`modal:${key}:open`, cb);
    },

    emitCloseModal(key = '') {
      this.eventHub.$emit(`modal:${key}:close`);
    },

    emitAddToaster(data) {
      this.eventHub.$emit('toaster:add', data);
    },
  },
};
